import {useQuery} from 'react-query'
import {SectionEditModalForm} from './SectionEditModalForm'
import {ID, isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'

import { getOneById } from '../../../../services/common_requests'
import { useListView } from '../../pages-list/core/ListViewProvider'
type Props = {
  pageId: ID
  sectionId: ID // Ajouter cette ligne
  onSuccess: () => void
  onClose: () => void
}
const SectionEditModalFormWrapper = ({ pageId, sectionId, onSuccess, onClose }: Props) => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: Section,
    error,
  } = useQuery(
    `${QUERIES.SECTION_LIST}-section-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/blocks")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  // Définir la section initiale
  const initialSection = {
  
    title: '',
    position: 0,
    attributes: [],
    translations: [{ language: 'en', title: '' }]
  }
console.log("*****itemIdForUpdate"+itemIdForUpdate)
  if (!itemIdForUpdate) {
    console.log("*****itemIdForUpdate***//"+itemIdForUpdate)
    return (
      <SectionEditModalForm 
        isSectionLoading={isLoading}
        Section={initialSection}
        pageId={pageId}
        onSuccess={onSuccess}  // Add missing prop
        onClose={onClose}      // Add missing prop
      />
    )  }

  if (!isLoading && !error && Section) {
    console.log("*****itemIdForUpdate*---"+itemIdForUpdate)
    return (
      <>
        {itemIdForUpdate && (
          <SectionEditModalForm
            isSectionLoading={isLoading}
            Section={itemIdForUpdate === ('new' as unknown as ID) ? initialSection : Section}
            pageId={pageId}
            onSuccess={onSuccess}  // Add this
            onClose={onClose} 
          />
        )}
      </>
    )
  }

  return null
}

export {SectionEditModalFormWrapper}
